import { Suspense, useEffect, useState } from 'react'
import { CostCentersPie } from '@/routes/costcenters/CostCentersPie'
import { Await } from 'react-router-typesafe'
import LoadingPanel from '@/components/loading-panel/LoadingPanel'
import { ActivitiesSummaryCardProps } from '@/routes/home/card/Card.types'

const ActivitiesSummaryCard = (props: ActivitiesSummaryCardProps) => {
  const { getCurrentEmployee } = props

  const [currentCriteria, setCurrentCriteria] = useState<{ id: string; nome: string }>()

  useEffect(() => {
    let criteria: { id: string; nome: string } = { id: 'centro_costo.nome', nome: 'CENTRO DI COSTO' }
    const criteriaLocalStorage = localStorage.getItem(`activities-summary-card-criteria`)
    if (criteriaLocalStorage !== undefined && criteriaLocalStorage !== null && criteriaLocalStorage !== '')
      criteria = JSON.parse(criteriaLocalStorage) satisfies { id: string; nome: string }
    setCurrentCriteria(criteria)
  }, [])

  return (
    <>
      <Suspense fallback={<LoadingPanel position={{ of: '#costCenterPieContainer' }} shading={false} />}>
        <Await resolve={Promise.resolve(getCurrentEmployee)}>
          {(currentEmployee) => (
            <>
              {currentEmployee?.data ? (
                <CostCentersPie initialCriteria={currentCriteria} employee={currentEmployee.data.value[0]} />
              ) : (
                <div>Impiegato non trovato</div>
              )}
            </>
          )}
        </Await>
      </Suspense>
    </>
  )
}

export default ActivitiesSummaryCard
